import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbAccountApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'db-account';
    }

    /**
     * 获取全部数据
     */
    public async getListAll() {
        return await this.send({}, 'getListAll', Methods.GET);
    }

    // public getDbProgramByDbId(moduleId: number) {
    //     return this.send({ moduleId }, 'getDbProgramByDbId', Methods.GET);
    // }

    public async dbAccountSaveOrUpdate(datas) {
        return await this.send(datas, 'dbAccountSaveOrUpdate', Methods.POST);
    }

    public async getAccountListByDbId(DbId) {
        return await this.send({DbId:DbId}, 'getAccountListByDbId', Methods.GET);
    }
    public async GeneratingAuthorizationCode(code) {
        return await this.send({code:code}, 'GeneratingAuthorizationCode', Methods.GET);
    }

    
}